










































import Vue  from 'vue'
import { FACET_QUERY_PREFIX } from '@/search/const'
import { SearchFacets } from '@/search/types'
import { getFacetsAllTypeDetail } from '@/common/components/facets/helper'
import { SYSTEM_ERROR } from '@/common/constants'
export default Vue.extend({
  name: 'FacetsLink',
  components: {
  },
  props: {
    categoryId: {
      type: Number,
      default: undefined
    },
    isShowCategoryFacets: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    facetItems: SearchFacets[]
    toggleSection: Array<number>
  } {
    return {
      facetItems: [],
      toggleSection: []
    }
  },
  computed: {
    queryParams(): number[] {
      return this.categoryId ? [this.categoryId] : []
    },
    categorySuffix(): string {
      return this.categoryId ? `&category=${this.categoryId}` : ''
    }
  },
  async created() {
    const { data } = await getFacetsAllTypeDetail(this.queryParams, false).catch(()=> alert(SYSTEM_ERROR.UNKNOWN))
    if (data) this.facetItems = data?.productSearchResults?.facets
    if (this.isShowCategoryFacets) {
      const { data } = await getFacetsAllTypeDetail(this.queryParams, true).catch(()=> alert(SYSTEM_ERROR.UNKNOWN))
      if (data.productSearchResults?.facets) this.facetItems = this.facetItems.concat(data.productSearchResults?.facets)
    }
  },
  methods: {
    searchByFacets(facetKey: string, facetValue: string) {
      window.location.href = `/search?${FACET_QUERY_PREFIX}${facetKey}=${facetValue}${this.categorySuffix}`
    },
    toggleFacet(id: string) {
      const facetId = Number(id)
      if (this.toggleSection.includes(facetId)) {
        this.toggleSection.splice(this.toggleSection.indexOf(facetId, 1))
      }
      else this.toggleSection.push(facetId)
    }
  }
})
